var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLineGraph = function SvgIconLineGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14A1.5 1.5 0 0 0 7 12.5a.77.77 0 0 0 0-.15l2.79-2.79h.46l1.61 1.61v.08a1.5 1.5 0 1 0 3 0v-.08L18.5 7.5A1.5 1.5 0 1 0 17 6a.767.767 0 0 0 0 .15l-3.61 3.61h-.16L11.5 8a1.5 1.5 0 1 0-3 0l-3 3a1.5 1.5 0 1 0 0 3ZM19 18H2V1a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z",
    fill: "currentColor"
  })));
};
export default SvgIconLineGraph;